import React from 'react';
import './Banner.css';

function Banner() {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="banner">
      <div className="banner-overlay"></div>
      <div className="banner-content">
        <h1>Transforming Ideas Into Digital Reality</h1>
        <p>
          CloudShift Technologies Private Limited is your trusted partner for 
          IT Consultancy, Web Applications, and Mobile App Development. 
          We deliver innovative solutions that drive business growth.
        </p>
        <div className="banner-buttons">
          <button className="btn btn-primary" onClick={() => scrollToSection('services')}>
            Our Services
          </button>
          <button className="btn btn-secondary" onClick={() => scrollToSection('contact')}>
            Get In Touch
          </button>
        </div>
      </div>
    </section>
  );
}

export default Banner;
